import ReferralActionTypes from './types';

export const referralJoinStart = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_JOIN_START,
  payload: payload,
});

export const referralJoinSuccess = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_JOIN_SUCCESS,
  payload: payload,
});

export const referralJoinFailure = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_JOIN_FAILURE,
  payload: payload,
});

export const referralLinkStart = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_LINK_START,
  payload: payload,
});

export const referralLinkSuccess = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_LINK_SUCCESS,
  payload: payload,
});

export const referralLinkFailure = (payload: any) => ({
  type: ReferralActionTypes.REFERRAL_LINK_FAILURE,
  payload: payload,
});

export const referralToasterShow = () => ({
  type: ReferralActionTypes.REFERRAL_TOASTER_SHOW,
});

export const referralToasterHide = () => ({
  type: ReferralActionTypes.REFERRAL_TOASTER_HIDE,
});
